import React from 'react';

/**
 * 昇順 / 降順をクリックで切り替えるトグル
 */
const SortOrderToggle = ({ order, onToggle, className = '' }) => {
  const isAsc = order === 'asc';

  return (
    <button
      type="button"
      className={`sort-order-toggle${isAsc ? ' is-asc' : ' is-desc'}${className ? ` ${className}` : ''}`}
      onClick={onToggle}
      aria-label={isAsc ? '昇順（クリックで降順に切り替え）' : '降順（クリックで昇順に切り替え）'}
      title={isAsc ? '昇順' : '降順'}
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
        {isAsc ? (
          <>
            <path d="M12 19V5" />
            <polyline points="5 12 12 5 19 12" />
          </>
        ) : (
          <>
            <path d="M12 5v14" />
            <polyline points="19 12 12 19 5 12" />
          </>
        )}
      </svg>
      <span>{isAsc ? '昇順' : '降順'}</span>
    </button>
  );
};

export default SortOrderToggle;
